import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseViewComponent, Environment, IconItem, ProductName, VariantManager } from '@sb/library/base';
import { EventColorEnum, ParentSignupInputItem, TagDisplayItem } from '@sb/library/data-models';
import { StyleManager } from '@sb/library/managers';
import { StudentSignupFrontendInputItem } from '../signup-form/signup-form.definitions';

@Component({
    selector: 'lib-widget-thank-you',
    templateUrl: './widget-thank-you.component.html',
    styleUrls: ['./widget-thank-you.component.scss']
})
export class WidgetThankYouComponent extends BaseViewComponent {

    @Input() thankYouMessage!: string | null;
    @Input() parent!: ParentSignupInputItem;

    private _subjectTagByID: Record<string, TagDisplayItem> = {};
    @Input() set subjectTags(value: TagDisplayItem[]) {
        this._subjectTagByID = {};
        value.forEach(subjectTag => this._subjectTagByID[subjectTag.ID!] = subjectTag);
    }

    private _students: StudentSignupFrontendInputItem[] = [];
    @Input() set students(value: StudentSignupFrontendInputItem[]) {
        this._students = value;
        if (this._students.length && this._Environment.Application.ProductName !== ProductName.Local) { //only for signup widget
            this.StartInactivityTimer();
        }

        this._isParentAStudent = this.IsParentAStudent();
    }
    
    @Output() addStudentClicked: EventEmitter<void> = new EventEmitter();
    @Output() doneClicked: EventEmitter<void> = new EventEmitter();

    private _inactivityTimeout: ReturnType<typeof setTimeout> | null = null; // Type for the timeout
    private _isParentAStudent: boolean = false;

    constructor(
        private _Environment: Environment,
        private _VariantManager: VariantManager,
        private _StyleManager: StyleManager
    ) {
        super();
    }

    AddStudentClicked(): void {
        if (this._inactivityTimeout) {
            clearTimeout(this._inactivityTimeout);
        }
        this.addStudentClicked.emit();
    }

    DoneClicked(): void {
        if (this._inactivityTimeout) {
            clearTimeout(this._inactivityTimeout);
        }
        this.doneClicked.emit();
    }

    BackgroundColorClass(color: EventColorEnum): string {
        return this._StyleManager.GetBackgroundColorCssClass(color);
    }

    GetInitial(name: string): string {
        return name.substring(0, 1);
    }

    private StartInactivityTimer(): void {
        this._inactivityTimeout = setTimeout(() => this.DoneClicked(), 300000);
    }

    private IsParentAStudent(): boolean {
        return this._students.some(student => student.Parent == this.parent && student.IsAdult);
    }

    get isParentAStudent(): boolean {
        return this._isParentAStudent;
    }

    get subjectIcon(): IconItem {
        return this._VariantManager.subjectIconName;
    }

    get students(): StudentSignupFrontendInputItem[] {
        return this._students;
    }

    get subjectTagByID(): Record<string, TagDisplayItem> {
        return this._subjectTagByID;
    }
}
